exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MedsSelect{margin:20px 0}.MedsSelect.error .MedsSelect-header{color:var(--text-negative)}.MedsSelect-header{font-size:14px;font-weight:500;margin-bottom:16px}.MedsSelect-search{margin-bottom:4px;position:relative}.MedsSelect-search input{padding-left:30px}.MedsSelect-search img{width:14px;position:absolute;left:10px;top:12px}.MedsSelect-list{height:247px;border:solid 1px var(--border-secondary);border-radius:4px;overflow:auto}.MedsSelect-noMedications{font-size:14px;margin-top:10px;margin-left:17px}.MedsSelect-footer{font-size:14px;font-weight:500;margin:8px 0}", ""]);

// exports
